import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Table } from 'reactstrap';
import stores from 'cd-eft/models/Stores';
import { mdiExitToApp } from '@mdi/js';
import './DEMSurfaceSummaryTable.scss';
import { DesignSummaryButtons } from 'cd-eft/components/Design/common/DesignSummaryButtons';
import Icon from '@mdi/react';
import { mdiAlertCircleOutline } from '@mdi/js';
import { DEMSurfaceSummaryTableVM, getDEMs } from './DEMSurfaceSummaryTableVM';
import { SurveyEngineeringStore } from 'cd-eft/models/Stores/SurveyEngineeringStore';
import { ActionsMenu } from 'cd-eft/components/Design/common/ActionsMenu';
import { DeleteElement } from 'cd-eft/components/Design/common/DeleteElement';

const surveyEngineeringStore = stores.AppStore.surveyEngineeringStore;
const { designStore } = stores.AppStore;

const DEMSurfaceSummaryTableComponent = (props) => {
  const vm = useRef(new DEMSurfaceSummaryTableVM(props)).current;
  //surveyButtonDisabled
  const handleButtonClick = () => {
    props.surveyButtonDisabled();
  };
  useEffect(() => {
    getDEMs();
  }, []);

  return (
    <>
      {(
        <div className="set-table-container width-auto">
          <Table className="set-table">
            <thead>
              <tr>
                <th className="narrow-td">Select</th>
                <th>Name</th>
                <th>Type</th>
                <th>Pixel Size</th>
                <th>Date</th>
                <th className="narrow-td">Actions</th>
              </tr>
            </thead>
            <tbody>
              {surveyEngineeringStore.demSurfaceSummaryTable.map((item: any, i) => {
                return (
                  <tr key={'key' + i}>
                    <td className="text-center">
                      <input
                        id={'select' + i}
                        data-testid={'select' + i}
                        name="select"
                        type="checkbox"
                        checked={surveyEngineeringStore.selectedSurveysInfo.includes(item.surveyId)}
                        value={i}
                        onChange={vm.handleCheckboxChange}
                      />
                    </td>
                    <td>
                      <label htmlFor={'select' + i} className="text-normal m-0 link">
                        {item.demSurfaceName}
                      </label>
                    </td>
                    <td>{item.demType}</td>
                    <td>{item.demPixelSize}</td>
                    <td>{item.demUploadDate}</td>
                    <td>
                    <ActionsMenu i={i} item={item} elementActions={vm.elementActions} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          {!surveyEngineeringStore.isLoading && !designStore.isLoading && surveyEngineeringStore.demSurfaceSummaryTable.length === 0 && (
            <div className="h4 m-5 text-center">Add your first DEM Surface</div>
          )}
        </div>


      )}
      <div className="form-row-fixed-height justify-content-between my-4" >
        <div>
          <button
            className="usa-button"
            id={`addSurvey`}
            data-testid={`addSurveyButton`}
            disabled={surveyEngineeringStore.savedDEM}
            onClick={vm.importDEMHandler}
          >
            Add DEM
          </button>
        </div>

        <div className="display-flex align-items-center">
          <div>
            <button
              data-testid="refreshElements"
              className={`usa-button ${surveyEngineeringStore.surveySummaryTable.length === 0 ? 'usa-button--disabled' : 'usa-button--outline'}`}
            //TODOS: Update Display DEM onclick function
            //onClick={ }
            >
              Display DEM
            </button>
            <button
              data-testid="refreshElements"
              className={`usa-button ${surveyEngineeringStore.surveySummaryTable.length === 0 ? 'usa-button--disabled' : 'usa-button--outline'}`}
            //TODOS: Update Display Contour onclick function
            //onClick={ }
            >
              Display Contour
            </button>
          </div>
        </div>

        {/* popups */}

        {vm.deleteDEMWindowIsOpen && (
          <DeleteElement
            trigger={vm.deleteDEMWindowIsOpen}
            setTrigger={vm.toggleDeleteDEM}
            element="DEM Surface"
            name={vm.demToDelete.demName}
            action={vm.deleteDEM}
          />
        )}

      </div>
    </>
  );
};

export const DEMSurfaceSummaryTable = observer(DEMSurfaceSummaryTableComponent);
